import { Platform, View } from 'react-native';
import {
    PanGestureHandler as GHPanGestureHandler,
    State as GHState,
    ScrollView as GHScrollView,
    FlatList as GHFlatList,
    PanGestureHandlerProperties,
} from 'react-native-gesture-handler';
import { ScrollView as RNScrollView, FlatList as RNFlatList } from 'react-native';
import React, { PropsWithChildren } from 'react';

/**
 * 增加一个一码多投的适配
 */

let _ScrollView: typeof GHScrollView, _FlatList: typeof GHFlatList, _PanGestureHandler: typeof GHPanGestureHandler;

if (Platform.OS === 'web') {
    _ScrollView = RNScrollView;
    _FlatList = RNFlatList;
    _PanGestureHandler = (props: PropsWithChildren<PanGestureHandlerProperties>) => {
        return <View>{props.children}</View>;
    };
} else {
    _ScrollView = GHScrollView;
    _FlatList = GHFlatList;
    _PanGestureHandler = GHPanGestureHandler;
}

export const ScrollView = _ScrollView;
export const FlatList = _FlatList;
export const PanGestureHandler = _PanGestureHandler;
export const State = GHState;
